import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconBuilding } from '../../../Assets/contacts/IconBuilding';
import { IconAgency } from '../../../Assets/contacts/IconAgency';
import { IconLocation } from '../../../Assets/contacts/IconLocation';
import { IconRouting } from '../../../Assets/panels/IconRouting';
import { Dictionery } from '../../../Data/Dictionery';
import { DictioneryPanel } from '../../../Data/DictioneryPanel';
import { formatPrice } from '../../Functions/Price';

const Styles = styled(Link)`
    flex-grow: 1;
    /* min-width: 30%; */
    width: calc(calc(100% - 2rem));
    margin: 1px;
    padding: 1rem;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    position: relative;
    border-radius: var(--border-radius-32);
    background-color: var(--n-grey-0);
    text-decoration: none;
    color: inherit;
    box-shadow: 0px 23px 40px -13px #00000014;
    &.big {
      width: calc(100% - 2rem);
    }
    /* border: 1px solid; */
    /* border-image-source: linear-gradient(180deg, #E5E5E5 0%, rgba(229, 229, 229, 0) 100%); */
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
        border-radius: calc(var(--border-radius-32) + 1px);
    }
    .image {
        width: 30%;
        aspect-ratio: 1.7;
        height: min-content;
        overflow: hidden;
        border-radius: var(--border-radius-3);
        position: relative;
        background-color: var(--n-grey-01);
        .icon-def {
          position: absolute;
          top: calc(50% - 24px);
          right: calc(50% - 24px);
          display: block;
          fill: var(--n-grey-2);
          z-index: 1;
        }
        img {
          position: relative;
          z-index: 2;
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
    }
    .line-v {
      width: 1px;
      background-color: var(--n-grey-1);
    }
    
    .data, .data-2 {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      gap: 1rem;
      margin: 0.5rem 1rem;
      
      .title {
        text-align: start;
        font-size: 1.25rem;
        font-weight: 700;
        color: inherit;
      }
      .desc-main {
        font-size: 0.9rem;
        font-weight: 600;
        color: var(--n-grey-2);
        white-space: pre-wrap;
        max-height: calc(0.9rem * 1.62 * 4);
        overflow: hidden;
      }
      .more-detail {
        margin: -1rem 0 -0.5rem;
      }
      .desc {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        font-size: 0.9rem;
        font-weight: 600;
        /* white-space: nowrap; */

        svg {
          fill: var(--n-grey-2);
          width: 32px;
          height: 32px;
          display: block;
        }
      }
      .line {
        height: 1px;
        background-color: var(--n-grey-1);
      }
    }
    .data {
      flex-grow: 1;
      width: 60%;
    }
    .data-2 {
      width: 10%;
      margin: 0.5rem;
    }
    
`
export default function TourCartBig (props){
  const {v, i, lan="en", big=false} = props;
  return (
    <Styles 
      key={i} 
      to={`/${lan.filename}/tour/${v.Continent_Url}/${v.Country_Url}/${v.City_Url}/${v.Tour_Id}`}
      // to={"/" + lan.filename + "/tours/" + v.Tour_Id} 
      className={(big ? "big" : "")}
    >
      <div className='image'>
        <IconRouting className={"icon-def"}/>
        {
            (v.Tour_Image) ? (
                <img src={v.Tour_Image} alt={v.Tour_Desc} onError={(e) => e.target.style.opacity = 0}/>
            ) : ""
        }
      </div>
      <div className='data'>
        <div className='title'>
          {lan.filename === "fa" ? v.Tour_Name : v.Tour_EnName}
        </div>
        {
          (v.Currency_Id && v.Tour_Min_Price) ? (
            <>
            <div className='desc big' style={{alignItems: "center"}}>
              {DictioneryPanel.packagesDict.startingPrice[lan.filename]}: <span className='desc-link'>{formatPrice(v.Tour_Min_Price)}</span> {v.Currency_Name} 
            </div>
            </>
          ) : ""
        }
        <div className='desc-main '>
          {lan.filename === "fa" ? v.Tour_Desc : v.Tour_EnDesc}
        </div>
        <div className='more-detail'>
          ...
        </div>
        {
          lan.filename === "fa" ? (
            <>
            {
              (v.Agency_Name) ? (
                <>
                <div className='line'></div>
                <div className='desc'>
                  <div className='icon'>
                    <IconAgency/>
                  </div>
                  <div className='text'>
                    {Dictionery.organizer[lan.filename]}: {v.Agency_Name}
                  </div>
                </div>
                </>
              ) : ""
            }
            </>
          ) : (
            <>
            {
              (v.Agency_EnName) ? (
                <>
                <div className='line'></div>
                <div className='desc'>
                  <div className='icon'>
                    <IconAgency/>
                  </div>
                  <div className='text'>
                    {Dictionery.organizer[lan.filename]}: {v.Agency_EnName}
                  </div>
                </div>
                </>
              ) : ""
            }
            </>
          )
        }
        
      </div>
      <div className='line-v'></div>
      <div className='data-2'>
        {
          lan.filename === "fa" ? (
            <>
            {
              (v.City_Name && v.Country_Name) ? (
                <>
                <div className='desc'>
                  <div className='icon'>
                    <IconLocation/>
                  </div>
                  <div className='text'>
                    {v.Country_Name} - {v.City_Name}
                  </div>
                </div>
                </>
              ) : ""
            }
            </>
          ) : (
            <>
            {
              (v.City_EnName && v.Country_En_Name) ? (
                <>
                <div className='desc'>
                  <div className='icon'>
                    <IconLocation/>
                  </div>
                  <div className='text'>
                    {v.Country_En_Name} - {v.City_EnName}
                  </div>
                </div>
                </>
              ) : ""
            }
            </>
          )
        }
      </div>
    </Styles>
  )
}

